module.exports = __webpack_public_path__ + "img/STANDARDCHARTERED.28c73b2c.svg";